<template>
    <div class="bg-primary rounded-xl p-3 my-2" :class="defaultView ? 'md:flex' : ''">
        <div class="mb-4 md:mb-0" :class="!defaultView ? 'md:flex items-center' : 'md:flex-1'">
            <h3 v-if="defaultView" class="text-white font-semibold text-xl md:mr-14 mb-3">
                Buy this tyre now from trusted online retailers
            </h3>
            
            <p v-if="defaultView" class="text-white text-md md:mr-4 mb-3">
                Enter your {{ type === 'registration' ? 'reg' : 'size' }} to find the price for your car
            </p>

            <h3 v-if="!defaultView" class="text-white font-bold text-xl md:mr-4">
                Enter your {{ type === 'registration' ? 'reg' : 'size' }} to find the right size
            </h3>

            <RegistrationInput
                v-if="type === 'registration'"
                class="mr-2 max-w-[160px]"
                :modelValue="registration"
                @update:modelValue="$emit('update:registration', $event)"
            ></RegistrationInput>

            <SizeInputs
                v-else
                class="mr-2"
                :modelValue="size"
                @update:modelValue="$emit('update:size', $event)"
            ></SizeInputs>

            <AppButton class="h-10 mr-4" theme="secondary" :disabled="loading" type="submit">Go</AppButton>

            <button class="text-white underline align-top" :class="defaultView ? 'flex mt-4' : 'appearance-none ml-auto whitespace-nowrap'" type="button" @click="toggleType">
                {{ registration ? 'Enter' : 'Or enter' + (type === 'registration' ? ' your tyre' : '') }} {{ type === 'registration' ? 'size' : 'reg' }}
            </button>
        </div>

        <div v-if="defaultView" class="bg-white rounded-xl px-3 py-2 md:py-0" :class="[!prices ? 'flex justify-center items-center' : null, loading ? 'flex-1' : null]">
            <Transition v-if="!prices" name="fade" mode="out-in">
                <font-awesome-icon
                    class="animate-spin transition-all text-dark"
                    size="3x"
                    :icon="['fas', 'tire']"
                ></font-awesome-icon>
            </Transition>

            <TyreDetailPriceRow v-else v-for="price of prices" :price="price" :registration="registration"></TyreDetailPriceRow>
        </div>
    </div>
</template>

<script>
import RegistrationInput from "@/Components/Products/TyreSizeLookup/RegistrationInput";
import SizeInputs from "@/Components/Products/TyreSizeLookup/SizeInputs";
import AppButton from '@/Components/AppButton';
import TyreDetailPriceRow from "@/Components/Products/TyreSizeLookup/TyreDetailPriceRow";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    components: {AppButton, RegistrationInput, SizeInputs, TyreDetailPriceRow, FontAwesomeIcon},
    emits: ["update:registration", "lookup", "toggleType"],
    props: {
        registration: String,
        size: Object,
        type: String,
        prices: Array,
        defaultView: Boolean
    },
    inject: ["loading"],
    methods: {
        toggleType() {
            this.$emit("update:type", this.type === "registration" ? "size" : "registration");
        }
    }
}
</script>

<style scoped>

</style>
